/**
 * Counsel-owned copy for the Harbor Divorce product (WP19).
 *
 * Every string in this file is legally sensitive and is reviewed by
 * supervising family-law counsel before changes ship. Keep all UPL-adjacent
 * copy here — do not inline disclaimer, DV-screening, or refund wording in
 * components — so counsel has a single file to review.
 *
 * Review status: DRAFT — pending supervising-counsel sign-off. The DV
 * screening wording additionally requires review by a domestic-violence
 * organization before launch.
 */

/** Document-preparation posture: shown on the interview and packet pages. */
export const DOC_PREP_DISCLAIMER =
  'Harbor provides self-help document preparation and educational information, not legal ' +
  'advice. We are not a law firm and are not a substitute for an attorney.';

/** Short educational-only line for navigator (Tier A) pages. */
export const EDUCATIONAL_DISCLAIMER =
  'Educational only and not legal advice. Court rules change — always confirm with your ' +
  "court's official site or clerk.";

/**
 * DV screening question. Framed around safety (not "abuse"), answerable
 * without naming the behavior, with an explicit no-storage promise (the
 * backend strips dv_flag before persisting; only the gate outcome survives).
 * Wording to be finalized with a domestic-violence organization's guidance.
 */
export const DV_SCREEN_QUESTION = 'Do you feel safe in your relationship?';
export const DV_SCREEN_HINT =
  'If there has been violence or threats, we\u2019ll point you to people who can genuinely ' +
  'help. This answer is never stored.';

/**
 * Refund policy summary shown at checkout and on the packet page. Marketing
 * must never promise "guaranteed court acceptance" — we are a DIY
 * document-preparation service, not a review-backed one.
 */
export const REFUND_POLICY_SUMMARY =
  'Full refund any time before your packet is generated. If your state updates its forms, ' +
  'we regenerate your packet against the new official versions for free.';

/** Copilot / support posture: what Harbor will not answer. */
export const NO_ADVICE_NOTICE =
  'Harbor can explain what a form or term means, but cannot tell you what you should do. ' +
  'For advice about your specific situation, talk to a family law attorney licensed in ' +
  'your state.';
